import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import querystring from "querystring";
import { withRouter } from "react-router-dom";
import Drawer from "@material-ui/core/Drawer";
import MenuList from "./MenuList";
import UserInfo from "./UserInfo";
import {
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from "../../../constants/ActionTypes";
import { toggleCollapsedNav, updateWindowWidth } from "../../../actions";

const SideNav = () => {
  const dispatch = useDispatch();
  const { navCollapsed, drawerType, width, navigationStyle } = useSelector(
    ({ settings }) => settings
  );
  const { authUser } = useSelector(({ auth }) => auth);
  const { companySelected, menuNotificationRefresh } = useSelector(
    ({ main }) => main
  );

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  // โหลดเมนู + NotificationCount
  // silent = true คือโหลดซ้ำเบื้องหลัง ไม่ล้างเมนูเดิม/ไม่ขึ้น loading (กันเมนูกระพริบ)
  const fetchData = useCallback(
    async (silent = false) => {
      if (!silent) {
        setLoading(true);
        setData([]);
      }

      // let strCompany = ""
      // if (companySelected && companySelected.length > 0) {
      //   strCompany = companySelected.map(q => q.Division).join(',')
      // }

      const params = {
        company: authUser.company !== "#" ? authUser.company : "",
        // com: strCompany,
        username: authUser.username,
      };

      let queryString = querystring.stringify(params);

      const url = `${process.env.REACT_APP_API_URL}menu-permission/menuPermission?${queryString}`;

      try {
        const result = await axios(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("x-access-token")}`,
          },
        });
        // const resultData = result.data.data;
        // setData(resultData);
        if (result.data.data.length > 0) {
          const resultData = result.data.data.map((d) => {
            return {
              ...d,
            };
          });
          setData(resultData);
        } else {
          setData([]);
        }
      } catch (error) {
        console.log("fetchData", error);
      }
      if (!silent) {
        setLoading(false);
      }
    },
    [authUser]
  );

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // โหลด NotificationCount ใหม่เมื่อมีการเปลี่ยนแปลงเอกสาร (dispatch refreshMenuNotification())
  // เทียบกับค่าล่าสุดที่เห็น เพื่อให้ยิงเฉพาะตอน counter เปลี่ยนจริง ๆ
  const lastRefreshRef = useRef(menuNotificationRefresh);
  useEffect(() => {
    if (lastRefreshRef.current === menuNotificationRefresh) return;
    lastRefreshRef.current = menuNotificationRefresh;
    fetchData(true);
  }, [menuNotificationRefresh, fetchData]);

  useEffect(() => {
    window.addEventListener("resize", () => {
      dispatch(updateWindowWidth(window.innerWidth));
    });
  }, [dispatch]);

  const onToggleCollapsedNav = (e) => {
    const val = !navCollapsed;
    dispatch(toggleCollapsedNav(val));
  };

  let drawerStyle = drawerType.includes(FIXED_DRAWER)
    ? "d-xl-flex"
    : drawerType.includes(COLLAPSED_DRAWER)
      ? ""
      : "d-flex";
  let type = "permanent";
  if (
    drawerType.includes(COLLAPSED_DRAWER) ||
    (drawerType.includes(FIXED_DRAWER) && width < 1200)
  ) {
    type = "temporary";
  }

  if (navigationStyle === HORIZONTAL_NAVIGATION) {
    drawerStyle = "";
    type = "temporary";
  }
  return (
    <div className={`app-sidebar d-none ${drawerStyle}`}>
      <Drawer
        className="app-sidebar-content"
        variant={type}
        open={type.includes("temporary") ? navCollapsed : true}
        onClose={onToggleCollapsedNav}
        classes={{
          paper: "side-nav",
        }}
      >
        <UserInfo />
        <MenuList
          onToggleCollapsed={onToggleCollapsedNav}
          data={data}
          loading={loading}
        />
      </Drawer>
    </div>
  );
};

export default withRouter(SideNav);
